var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.04 22.03-4.26-2.84H8.89c-.23 0-.45-.11-.59-.29a.763.763 0 0 1-.13-.65 3 3 0 0 0 .09-.74c0-.8-.3-1.57-.84-2.17a3.2 3.2 0 0 0-2.41-1.08c-.89 0-1.71.35-2.33.98-.19.2-.48.27-.74.2a.77.77 0 0 1-.53-.56c-.1-.44-.15-.92-.15-1.44v-6c0-3.44 2.31-5.75 5.75-5.75h10c3.44 0 5.75 2.31 5.75 5.75v6c0 1.67-.55 3.11-1.6 4.16-.88.88-2.05 1.41-3.4 1.55v1.42c0 .65-.36 1.24-.93 1.55-.27.13-.55.2-.83.2-.34 0-.67-.1-.96-.29zM11 17.68c.15 0 .29.04.42.13l4.45 2.97c.11.07.2.04.25.01.05-.03.14-.09.14-.23v-2.13c0-.41.34-.75.75-.75 1.27 0 2.34-.4 3.09-1.15.76-.76 1.16-1.83 1.16-3.1v-6c0-2.58-1.67-4.25-4.25-4.25h-10c-2.58 0-4.25 1.67-4.25 4.25v5.88a4.69 4.69 0 0 1 2.25-.56c1.36 0 2.65.58 3.53 1.58a4.74 4.74 0 0 1 1.22 3.17c-.01.06-.01.12-.01.18H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25 17.5c0-1.46.65-2.81 1.78-3.71.84-.67 1.9-1.04 2.97-1.04 2.62 0 4.75 2.13 4.75 4.75 0 1.36-.59 2.66-1.62 3.56-.87.77-1.98 1.19-3.13 1.19-2.62 0-4.75-2.13-4.75-4.75zm2.72-2.53c-.77.61-1.22 1.54-1.22 2.53 0 1.79 1.46 3.25 3.25 3.25.78 0 1.54-.29 2.15-.81.7-.62 1.1-1.5 1.1-2.44 0-1.79-1.46-3.25-3.25-3.25-.74 0-1.44.25-2.03.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36 18.89c-.21-.36-.1-.82.26-1.03l.89-.53v-1.08c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 .26-.14.51-.36.64l-1.25.75c-.14.08-.27.11-.4.11-.25 0-.5-.13-.64-.36zM8.5 11.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageTime);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-time.7ee3b86805b926bd00cd2386b9b0ddef.svg";
export { ForwardRef as ReactComponent };